import arr from './arr-stats'
// import sampleMeta from '../refs/sampleMeta'
import sampleMeta from '../refs/newSampleMeta'
// import trackDetails from '../refs/trackDetails'
import trackDetails from '../refs/newTrackDetails'
import categoryTracks from '../refs/categoryTracks'

let trackCategory = {}
Object.entries(categoryTracks).forEach(([category, trackList]) => {
    trackList.forEach((track) => trackCategory[track] = category)
})

// export const transform_k_track_v_data = (k_track_v_data) => {
//     let samples = Object.keys(sampleMeta)
//     const sampleMetaTransformed = transformSampleMeta()
//     let res = sampleMetaTransformed
//     Object.entries(k_track_v_data).forEach(([track, data]) => {
//         if (track.includes('mut')) { return }
//         const gene = track.split(' ')[0]
//         const dataType = track.split(' ')[1]

//         const raw_z_tumor = samples
//             .map(sample => k_track_v_data[track][`${sample}-T`])
//         const raw_z_normal = samples
//             .map(sample => k_track_v_data[track][`${sample}-N`])
//         const raw_z = [...raw_z_tumor, ...raw_z_normal]
//             .filter(el => el && !(typeof el === 'string'))
//         const z_scores = arr.zScores(raw_z)
//         const zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
//         const tumorKey = `${track} T`
//         const normalKey = `${track} N`
//         let tumorData = createTissueObj({
//             trackObj: k_track_v_data[track], 
//             tissueStr: '-T',
//             zScoreDict,
//         })
//         let normalData = createTissueObj({
//             trackObj: k_track_v_data[track], 
//             tissueStr: '-N',
//             zScoreDict,
//         })
//         res[tumorKey] = {
//             title: tumorKey,
//             data: tumorData,
//             clinical: false,
//             clinicalData: null,
//             gene,
//             dataType,
//             tissue: 'tumor',
//             parent: track,
//         }
//         res[normalKey] = {
//             title: normalKey,
//             data: normalData,
//             clinical: false,
//             clinicalData: null,
//             gene,
//             dataType,
//             tissue: 'normal',
//             parent: track,
//         }
//     })
    
//     return res
// }


// export const transform_k_track_v_data = (k_track_v_data) => {

//     let samples = Object.keys(sampleMeta)
//     const sampleMetaTransformed = transformSampleMeta()
//     let res = sampleMetaTransformed
    
//     Object.entries(k_track_v_data).forEach(([track, data]) => {
//         if (track.includes('mut')) { return }
//         const gene = track.split(' ')[0]
//         const dataType = track.split(' ')[1]

//         // const raw_z_tumor = samples
//         //     .map(sample => k_track_v_data[track][`${sample}`])
//         const raw_z_normal = samples
//             .map(sample => k_track_v_data[track][`${sample}`])
//         const raw_z = [...raw_z_normal]
//             .filter(el => el && !(typeof el === 'string'))
//         const z_scores = arr.zScores(raw_z)
//         const zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
        
//         // const tumorKey = `${track} T`
//         const normalKey = `${track} N`
//         // let tumorData = createTissueObj({
//         //     trackObj: k_track_v_data[track], 
//         //     tissueStr: '-T',
//         //     zScoreDict,
//         // })
//         let normalData = createTissueObj({
//             trackObj: k_track_v_data[track], 
//             tissueStr: '-N',
//             zScoreDict,
//         })

//         console.log(normalData)

//         // res[tumorKey] = {
//         //     title: tumorKey,
//         //     data: tumorData,
//         //     clinical: false,
//         //     clinicalData: null,
//         //     gene,
//         //     dataType,
//         //     tissue: 'tumor',
//         //     parent: track,
//         // }
//         res[normalKey] = {
//             title: normalKey,
//             data: normalData,
//             clinical: false,
//             clinicalData: null,
//             gene,
//             dataType,
//             tissue: 'normal',
//             parent: track,
//         }
//     })
    
//     return res
// }

// suspicion that the code is here

export const transform_k_track_v_data = (k_track_v_data) => {

    let samples = Object.keys(sampleMeta)
    const sampleMetaTransformed = transformSampleMeta()
    let res = sampleMetaTransformed

    console.log("printing sample meta in transform_k_track_v_data");
    console.log(sampleMeta)
    
    Object.entries(k_track_v_data).forEach(([track, data]) => {
        if (track.includes('mut')) { return }
        const gene = track.split(' ')[0]
        const dataType = track.split(' ').slice(1).join(" ")

        // const raw_z_tumor = samples
        //     .map(sample => k_track_v_data[track][`${sample}`])
        const raw_z_normal = samples
            .map(sample => k_track_v_data[track][`${sample}`])

        
        const raw_z = [...raw_z_normal]
            .filter(el => el && !(typeof el === 'string'))
        
        const z_scores = arr.zScores(raw_z)
        const zScoreDict = Object.fromEntries(raw_z.map((v, i) => [v, z_scores[i]]))
        
        
        // const tumorKey = `${track} T`
        // const normalKey = `${track} N`

        const maleKey = `${track} Male`
        const femaleKey = `${track} Female`

        // let tumorData = createTissueObj({
        //     trackObj: k_track_v_data[track], 
        //     tissueStr: '-T',
        //     zScoreDict,
        // })
        
        let maleData = createTissueObj({
            trackObj: k_track_v_data[track] , 
            tissueStr: 'Male',
            zScoreDict,
        })

        let femaleData = createTissueObj({
            trackObj: k_track_v_data[track] , 
            tissueStr: 'Female',
            zScoreDict,
        })

        // let normalData = createTissueObj({
        //     trackObj: k_track_v_data[track] , 
        //     tissueStr: '-N',
        //     zScoreDict,
        // })
       


        // res[tumorKey] = {
        //     title: tumorKey,
        //     data: tumorData,
        //     clinical: false,
        //     clinicalData: null,
        //     gene,
        //     dataType,
        //     tissue: 'tumor',
        //     parent: track,
        // }
        // res[normalKey] = {
        //     title: normalKey,
        //     data: normalData,
        //     clinical: false,
        //     clinicalData: null,
        //     gene,
        //     dataType,
        //     tissue: 'normal',
        //     parent: track,
        // }

        res[maleKey] = {
            title: maleKey,
            data: maleData,
            clinical: false,
            clinicalData: null,
            gene,
            dataType,
            tissue: 'male',
            parent: track,
        }

        res[femaleKey] = {
            title: femaleKey,
            data: femaleData,
            clinical: false,
            clinicalData: null,
            gene,
            dataType,
            tissue: 'female',
            parent: track,
        }

        
        

    })

    // console.log(res)
    
    return res
}


function createTissueObj({
    trackObj,
    tissueStr,
    zScoreDict,
  }) {

    // console.log("Printing trackObj in helpers/index.js");
    // console.log(trackObj);

    // // i want to filter for only the items in trackObj that begin with the character 7 
    // const filteredTrackObj = Object.fromEntries(Object.entries(trackObj).filter(([sample, value]) => sample[0] === '7'));


    // console.log("Printing sampleMeta in helpers/index.js");

    // console.log(Object.fromEntries( Object.keys(filteredTrackObj)
    // .filter( key => sampleMeta[key].Sex === tissueStr  )
    // .map( key => [ key, zScoreDict[trackObj[key]] ] )) )

    // return Object.fromEntries( Object.keys(filteredTrackObj)
    //     .filter( key => sampleMeta[key].Sex === tissueStr  )
    //     .map( key => [ key, zScoreDict[trackObj[key]] ] ))

    // filteredTrackObj.fr((sample, value) => {
    //     console.log(sample);
    // }
    // )
//     console.log(Object.fromEntries(Object.keys(filteredTrackObj)
//         .filter(sample => sample && sample.Sex === tissueStr)
//         .map(sample => [ 
//         //   sample.split(tissueStr)[0],
//             sample,
//             zScoreDict[trackObj[sample]]
//         ]
//         )
//   ));

    return Object.fromEntries(Object.keys(trackObj)
    //   .filter(sample => sample && sampleMeta[sample] && sampleMeta[sample].Sex === tissueStr)
      .map(sample => [ 
        //   sample.split(tissueStr)[0],
          sample,
          zScoreDict[trackObj[sample]]
        ]
      )
    )
  }

  export const transformSampleMeta = () => {
      let res = {}
      
      Object.entries(sampleMeta).forEach(([sample, meta]) => {
        Object.entries(meta).forEach(([track, val]) => {
            if (!(track in res)) { res[track] = {
                title: track,
                data: {},
                clinical: true,
                clinicalData: {
                    trackDetails: trackDetails[track],
                    group: trackCategory[track],
                    numerical: trackCategory[track] === 'Numerical',
                    show: true,
                },
                gene: null,
                dataType: null,
                tissue: null,
            } }
            res[track].data[sample] = val
        })
      })
      return res
}


export const combine_k_track_v_data_NOT_normalized = (k_track_v_data) => {
    const sampleMetaTransformed = transformSampleMeta()
    let res = sampleMetaTransformed
    Object.entries(k_track_v_data).forEach(([track, data]) => {
        if (track.includes('mut')) { return }
        const gene = track.split(' ')[0]
        
        const dataType = track.split(' ').slice(1).join(" ")


        // doesn't match Patient ID
        
        // console.log("Printing Sample Meta")
        // console.log(sampleMeta)

        const maleKey = `${track} Male`
        const femaleKey = `${track} Female`

        const normalKey = `${track} N`



        // console.log(k_track_v_data)
        // console.log(track)
        // console.log( k_track_v_data[ track ]  )
        console.log(sampleMeta)
        

        // const tracksWithSex = Object.fromEntries( Object.entries(k_track_v_data[track])
        // .filter( ([sample, v]) =>  sample.Sex != undefined) 
        // .map( ([sample, v] ) => [sample, v])
        const tracksWithSex = Object.values(k_track_v_data[track]).filter(obj => 
            Object.prototype.hasOwnProperty.call(obj, 'Sex')
        );

        let maleData = Object.fromEntries( Object.entries(k_track_v_data[track])
            .filter(([sample, v]) =>  
                        Object.prototype.hasOwnProperty.call(sampleMeta, sample) 
                        && Object.prototype.hasOwnProperty.call(sampleMeta[sample], 'Sex') 
                        && sampleMeta[sample]['Sex'] === "Male" )
            .map(([sample, v]) => [sample, v]))
        
        let femaleData = Object.fromEntries(Object.entries(k_track_v_data[track])
            .filter(([sample, v]) => Object.prototype.hasOwnProperty.call(sampleMeta, sample) 
                && Object.prototype.hasOwnProperty.call(sampleMeta[sample], 'Sex') 
                && sampleMeta[sample]['Sex'] === "Female" )
            .map(([sample, v]) => [sample, v]))
        
        // console.log("looking at male and female data")
        // console.log("CHECKING HERE RIGHT NOW!!!")

        //  console.log(maleData)
        //  console.log(femaleData)

        // let tumorData = Object.fromEntries(Object.entries(k_track_v_data[track])
        //     .filter(([sample, v]) => sample.includes('-T'))
        //     .map(([sample, v]) => [sample.split('-T')[0], v]))

        let normalData = Object.fromEntries(Object.entries(k_track_v_data[track])
            // .filter(([sample, v]) => sample.includes('-N'))
            // .map(([sample, v]) => [sample.split('-N')[0], v]))
            .map(([sample, v]) => [sample, v]))

        // console.log("looking at male Data")
        // console.log(maleData)
        res[maleKey] = {
            title: maleKey,
            data: maleData,
            clinical: false,
            clinicalData: null,
            gene,
            dataType,
            tissue: 'male',
            parent: track,
        }

        res[femaleKey] = {
            title: femaleKey,
            data: femaleData,
            clinical: false,
            clinicalData: null,
            gene,
            dataType,
            tissue: 'female',
            parent: track,
        }
    })

    console.log("Looking at res")
    console.log(res)
    
    return res
}
